module.exports = __webpack_public_path__ + "static/media/Naked.0d430137.svg";